import { Note } from "../gateway/Note/Note";
import { UserDataAdapter } from "../presentation/adpters/UserDataAdapter";
import * as DateUtils from "../utils/date/date";

export class SaveCommentUsecase {
    constructor() {
        this.NoteGateway = new Note();
    }

    async execute({
        accountingId,
        report,
        comment,
        commentHTML,
        companyId,
        date,
        dashboardId,
        period,
        visualizationId,
        serieId,
        scenarioId,
        _id
    } = {}) {
        const payload = this.sanitizeInput({
            accountingId,
            report,
            comment,
            commentHTML,
            companyId,
            date,
            dashboardId,
            period,
            visualizationId,
            serieId,
            scenarioId,
            _id
        });
        if (!payload.comment) return this.NoteGateway.remove(payload._id);
        const _date = DateUtils.dateToDB(payload.date);
        const commentData = {
            _id: payload._id,
            accountingId: payload.accountingId,
            report: payload.report,
            comment: payload.commentHTML || payload.comment,
            companyId: payload.companyId,
            period: payload.period,
            date: {
                year: _date.getUTCFullYear(),
                month: _date.getUTCMonth() + 1
            },
            visualizationId: payload.visualizationId,
            serieId: payload.serieId,
            scenarioId: payload.scenarioId,
            userId: new UserDataAdapter().user()._id
        };
        return this.NoteGateway.save(commentData);
    }

    sanitizeInput({
        accountingId,
        report,
        comment = "",
        commentHTML = "",
        companyId,
        date,
        dashboardId,
        period,
        visualizationId,
        serieId,
        scenarioId,
        _id
    } = {}) {
        return {
            accountingId,
            report,
            comment: String(comment).trim(),
            commentHTML,
            companyId,
            date,
            dashboardId,
            period,
            visualizationId,
            serieId,
            scenarioId,
            _id
        };
    }
}
